import React from 'react'
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import fr from 'date-fns/locale/fr';
import "react-datepicker/dist/react-datepicker.css";

import { css } from 'emotion'

const DateFilter = (props) => {

  const {
    date,
    handleChange
  } = props

    // Enregistrez la localisation française
  registerLocale('fr', fr);

  // Définissez la localisation par défaut sur français
  setDefaultLocale('fr');

  return (
    <div className={css(styles.block)}>
      <DatePicker
        dateFormat="dd/MM/yyyy"
        onChange={handleChange}
        selected={date}
        className={css(styles.date)}
        locale="fr"
        calendarStartDay={1}
      />
    </div>
  )

}

const styles ={
  date:{
    background: 'none',
    border: 'thin solid #bbb',
    color: '#555',
    padding: '0.04rem 0.4rem'
  }
}
export default DateFilter
